// STEP 7d · D-e (owner decision 30-Oct-2026, 7a OQ-14) — the category of a specific-vouching sheet.
// The back end now applies a chosen category to the named vouchers (only their lines in that category); with no category
// every line is taken, as before. The form starts on "Opex" for the sampling methods, so choosing Specific vouching moves
// the category to "All categories" (the default for specific vouching — "as today"); leaving it puts the earlier choice back
// when the user did not change it.
import { SPECIFIC_METHOD } from "@/pages/Sampling/common";

export const ALL_CATEGORIES = "__all__";

export function formForMethod(form, method) {
  const was = form.method === SPECIFIC_METHOD;
  const now = method === SPECIFIC_METHOD;
  if (now && !was) {
    return { ...form, method, category_filter: ALL_CATEGORIES, category_before_specific: form.category_filter };
  }
  if (was && !now) {
    const { category_before_specific: before, ...rest } = form;
    const keep = form.category_filter !== ALL_CATEGORIES || before === undefined;
    return { ...rest, method, category_filter: keep ? form.category_filter : before };
  }
  return { ...form, method };
}

// The category sent to POST /samples (null = all categories).
export function categoryForBody(form) {
  return !form.category_filter || form.category_filter === ALL_CATEGORIES ? null : form.category_filter;
}
